const toArabicNumber = (n) => new Intl.NumberFormat('ar-SA').format(n);
const benefits = [
  `أكثر من ${toArabicNumber(17)} دورة و معسكر احترافي`,
  'شهادات موثقة فور اتمام أي دورة أو معسكر',
];
export const dailyPackage = [
  {
    planType: 'DAILY',
    title: 'اﻟﺈﺷﺘﺮاك اليومي',
    titleIcon: false,
    subtitle: 'يجدد الاشتراك يوميا',
    price: '1.99',
    discountedPrice: '1.99',
    benefits,
  },
];
export default [
  {
    planType: 'MONTHLY',
    title: 'اﻟﺈﺷﺘﺮاك اﻟﺸﻬﺮي',
    titleIcon: false,
    subtitle: 'يجدد الاشتراك شهريا',
    price: '14.99',
    discountedPrice: '9.99',
    benefits,
  },
  {
    planType: 'FULL_YEARLY',
    title: 'اﻟﺈﺷﺘﺮاك السنوي المميز',
    titleIcon: true,
    subtitle: 'باقة برمج المميزة بدفعة واحدة سنويا',
    price: '124.99',
    discountedPrice: '99.99',
    benefits: [
      ...benefits,
      `${toArabicNumber(
        2,
      )} جلسة مع مرشد لمساعدتك في الوصول الى هدفك من تعلم البرمجة `,
    ],
  },
  {
    planType: 'YEARLY',
    title: 'اﻟﺈﺷﺘﺮاك السنوي',
    titleIcon: false,
    subtitle: 'باقة الاشتراك السنوية',
    price: '114.99',
    discountedPrice: '89.99',
    benefits,
  },
];
